import { render, staticRenderFns } from "./MypageContactUsPane.vue?vue&type=template&id=55b62a13&scoped=true"
import script from "./MypageContactUsPane.vue?vue&type=script&lang=ts"
export * from "./MypageContactUsPane.vue?vue&type=script&lang=ts"
import style0 from "./MypageContactUsPane.vue?vue&type=style&index=0&id=55b62a13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b62a13",
  null
  
)

export default component.exports